import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ManagedCompaniesService } from 'src/app/core/services/managed-companies.service';
import { ThemeService } from 'src/app/core/services/theme.service';
import { UserProfileDataService } from 'src/app/core/services/user-profile.service';
import { AiChatComponent } from 'src/app/pages/ai/ai-chat/ai-chat.component';
import { CohortDataService } from 'src/app/pages/buyer/setup-cohorts/services/cohort.service';
import { GlobalService } from '../../../../portal/search-api/services/global.service';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [GlobalService],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  @ViewChild(MatMenu, { static: false }) menu: MatMenu;

  @Input() userName: string;
  @Input() searchTerm: string;

  @Input() userNameAs: string;
  @Input() isUserAs: boolean;

  @Output() logout = new EventEmitter();
  @Output() logoutAs = new EventEmitter();

  suggestionResponse: Array<{ result: string }>;
  searchControl = new FormControl();

  isBayerCaddy: boolean;
  dynamicParam: string;
  currentUrl: string;
  companies = [];

  selectedCompany;
  profileCompanyId;

  isRhetorikThemeActive = false;

  showAiChat = true;

  readonly dialog = inject(MatDialog);

  constructor(
    private searchService: GlobalService,
    public authService: AuthService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    public userProfileDataService: UserProfileDataService,
    private managedCompaniesService: ManagedCompaniesService,
    private cohortDataService: CohortDataService,
    private themeService: ThemeService,
  ) {
    this.activeRoute.queryParams.subscribe(() => {
      this.currentUrl = this.router.url;
    });
    this.isRhetorikThemeActive = this.themeService.isRhetorikTheme();
  }

  async ngOnInit(): Promise<void> {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.url;
        this.dynamicParam = this.currentUrl.split('/').pop();
      });
    this.userName = this.authService.getUserClaims()?.name;
    this.isBayerCaddy = JSON.parse(localStorage.getItem('isBayerCaddy'));
    await this.userProfileDataService.getUserData();
    this.profileCompanyId = this.userProfileDataService.userCompanyData?.id;

    this.managedCompaniesService.managedCompanies$.subscribe((companies) => {
      this.companies = companies;
      const newCompany = {
        id: this.userProfileDataService.userCompanyData?.id,
        name: this.userProfileDataService.userCompanyData?.name,
        domain: this.userProfileDataService.userCompanyData?.website,
        selected: false,
      };

      if (!this.companies.find(c => c.id === newCompany.id)) {
        this.companies.push(newCompany);
      }

      this.selectedCompany = this.companies.find((x) => x.selected);
      if (this.selectedCompany) {
        localStorage.setItem('companyId', this.selectedCompany.id);
      } else {
        this.selectedCompany = this.companies.find(
          (x) => x.id == this.profileCompanyId
        );
      }
    });
    this.cohortDataService.getDefaultCohort().toPromise();
  }

  switchToBuyerCaddy() {
    this.isBayerCaddy = true;
    localStorage.setItem('isBayerCaddy', 'true');
    this.router.navigate(['/buyer-home']);
  }

  switchToSalesCaddy() {
    this.isBayerCaddy = false;
    localStorage.setItem('isBayerCaddy', 'false');
    this.router.navigate(['/home']);
  }

  async gotoCompanyPage() {
    const id =
      localStorage.getItem('companyId') ||
      this.userProfileDataService.userProfileData?.company?.companyId;
    let url = '/company/' + id;
    this.router.navigate([url]);
  }
  isCurrentPage(page: string): boolean {
    return this.currentUrl.startsWith(page);
  }

  changeCompany(company) {
    if (company.id != this.profileCompanyId) {
      this.managedCompaniesService.updateManagedCompanies({
        ...company,
        selected: true,
      });
    } else {
      localStorage.removeItem('companyId');
      this.managedCompaniesService.updateManagedCompanies({
        ...this.companies.find((x) => x.selected),
        selected: false,
      });
    }

    const isCompanyPage = this.currentUrl.includes('/company');
    if(isCompanyPage){
      location.href = "/company/"+company.id;
    }
    else{
      location.reload();
    }
    // const guidRegex = /[0-9A-Fa-f]{32}$/; // регулярное выражение для GUID

    // if (guidRegex.test(location.pathname)) {
    //   const pathWithoutGuid = location.pathname.replace(guidRegex, '');
    //   location.href = pathWithoutGuid;
    // } else {
    //   location.href = location.pathname;
    // }


  }

  getSelectedCompany() {
    const selectedCompany = localStorage.getItem('companyId');
    if (selectedCompany) {
      this.selectedCompany = this.companies.find(
        (x) => x.id == selectedCompany
      );
      this.managedCompaniesService.updateManagedCompanies({
        ...this.selectedCompany,
        selected: true,
      });
    } else {
      this.selectedCompany = this.companies.find(
        (x) => x.id == this.userProfileDataService.userCompanyData?.id
      );
    }
  }

  public deleteCompanyFromManagmentList(companyId) {
    this.managedCompaniesService.deleteManagedCompany(companyId);
    // this.getSelectedCompany();
  }

  onLogoutAs(){
   this.logoutAs.emit()
  }

  onLogout(){
   this.logout.emit()
  }

  goToMyProfiles(){
    // this.contactSearchFiltersService.resetFilters();
    // this.contactSearchFiltersService.owned = true;
    // this.contactSearchFiltersService.filtersChanged=true;
    // localStorage.setItem('searchActiveTab', 'contacts');
    //this.router.navigate(['/products'],{ queryParams: { timestamp: new Date().getTime() }});
    this.router.navigate(['/my-contacts']);
  }

  goTo(str: string) {
    this.router.navigate([str]);
  }


  onThemeToggle(event: any) {
    if (this.isRhetorikThemeActive) {
      this.themeService.activateTheme('rhetorik-theme');
    } else {
      this.themeService.deactivateTheme('rhetorik-theme');
    }
  }

  startAi() {

    const dialogHeight = `${window.innerHeight - 70}px`;

    const dialogRef = this.dialog.open(AiChatComponent, {
      position: { right: '0', bottom:'0'},
      disableClose: true,
      hasBackdrop:false,
      height: dialogHeight,
      width: '600px',
      panelClass: ['animate__animated', 'animate__slideInUp'],
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '400ms',
    });
    this.showAiChat = false;

    dialogRef.beforeClosed().subscribe(() => {
      this.showAiChat = true;
      dialogRef.removePanelClass('animate__slideInUp');
      dialogRef.addPanelClass('animate__slideOutDown');
    });

  }
}
